// ===============================
// IMPORTS
// ===============================
import React from 'react';
import { Link } from 'react-router-dom'; // for routing
import {
  FaHome, FaChartLine, FaUserFriends, FaStore, FaUserTie,
  FaGift, FaBook, FaNewspaper, FaPenNib, FaBriefcase,
  FaComments, FaBullhorn, FaShieldAlt, FaTools, FaChartArea
} from 'react-icons/fa';

// ===============================
// NAVIGATION ITEMS
// ===============================
const navItems = [
  { icon: <FaHome className="text-blue-400" />, label: "Home", link: "/" },
  { icon: <FaChartLine className="text-pink-400" />, label: "Dashboard", link: "/dashboard" },
  { icon: <FaUserFriends className="text-indigo-400" />, label: "Directory", link: "/dashboard/directory" },
  { icon: <FaStore className="text-green-400" />, label: "Marketplace", link: "/marketplace" },
  { icon: <FaUserTie className="text-yellow-500" />, label: "Freelancers", link: "/freelancers" },
  { icon: <FaGift className="text-red-400" />, label: "Offers", link: "/offers" },
  { icon: <FaBook className="text-orange-400" />, label: "Library", link: "/library" },
  { icon: <FaNewspaper className="text-sky-400" />, label: "News", link: "/news" },
  { icon: <FaPenNib className="text-purple-400" />, label: "Blog", link: "/blog" },
  { icon: <FaBriefcase className="text-teal-400" />, label: "Investors", link: "/investors" },
  { icon: <FaComments className="text-cyan-400" />, label: "Chat", link: "/chat" },
  { icon: <FaBullhorn className="text-rose-400" />, label: "Promotions", link: "/promotions" },
  { icon: <FaChartLine className="text-fuchsia-400" />, label: "Signals", link: "/signals" },
  { icon: <FaShieldAlt className="text-lime-400" />, label: "Compliance", link: "/compliance" },
  { icon: <FaTools className="text-amber-400" />, label: "Creator Hub", link: "/creator" },
  { icon: <FaChartArea className="text-cyan-400" />, label: "Live Market", link: "/dashboard/live-market" },
];

// ===============================
// COMPONENT
// ===============================
export default function SubNavigationBar() {
  return (
    <nav className="bg-black text-white py-2 shadow-sm flex justify-center space-x-4 overflow-x-auto">
      {navItems.map((item, index) => (
        <Link
          key={index}
          to={item.link}
          onClick={() => {
            if (item.label === 'Home') {
              localStorage.setItem('fromDashboard', 'true');
            }
          }}
          className="flex flex-col items-center justify-center hover:text-yellow-400 transition w-16 text-xs"
        >
          <div className="text-lg mb-1">{item.icon}</div>
          <span>{item.label}</span>
        </Link>
      ))}
    </nav>
  );
}
